import React from "react";

const Address = () => {
  return (
    <div>
      <h1>Address</h1>
    </div>
  );
};

export default Address;
